import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 12a3 5 0 1 0 6 0a3 5 0 1 0 -6 0","key":"svg-1"}]]

const IconBrandOpera = createReactComponent('outline', 'brand-opera', 'BrandOpera', __iconNode);

export default IconBrandOpera;